'use strict';

var _commonjsHelpers = require('./_commonjsHelpers-755157d3.js');
var constants = require('./constants-d8339ee1.js');

var _require = constants.constants,
  NEW_RELIC_ACTION_NAME = _require.NEW_RELIC_ACTION_NAME;
function trackEvent(type) {
  var _window$newrelic;
  if (typeof ((_window$newrelic = window.newrelic) == null ? void 0 : _window$newrelic.addPageAction) === 'function') {
    window.newrelic.addPageAction(NEW_RELIC_ACTION_NAME, {
      HydrationType: type
    });
  }
}
var track = {
  trackEvent: trackEvent
};
var track$1 = _commonjsHelpers.getDefaultExportFromCjs(track);

exports.track = track;
exports.track$1 = track$1;
